module.exports = __webpack_public_path__ + "img/hrm-raymond.af290c7.png";